/**
 * Palette options DSFR (fichier source : @gouvfr/dsfr …/_options.scss).
 * Réf. doc : https://www.systeme-de-design.gouv.fr/version-courante/fr/fondamentaux/couleurs-palette
 */
export const DSFR_PALETTE_MAP = {
  "grey-0": {
    "default": "#000",
    "hover": "#000"
  },
  "grey-50": {
    "default": "#161616",
    "hover": "#343434"
  },
  "grey-75": {
    "default": "#1e1e1e",
    "hover": "#3f3f3f"
  },
  "grey-100": {
    "default": "#242424",
    "hover": "#474747"
  },
  "grey-125": {
    "default": "#2a2a2a",
    "hover": "#4e4e4e"
  },
  "grey-150": {
    "default": "#2f2f2f",
    "hover": "#545454"
  },
  "grey-175": {
    "default": "#353535",
    "hover": "#5c5c5c"
  },
  "grey-200": {
    "default": "#3a3a3a",
    "hover": "#616161"
  },
  "grey-425": {
    "default": "#666",
    "hover": "#919191"
  },
  "grey-625": {
    "default": "#929292",
    "hover": "#bbb"
  },
  "grey-850": {
    "default": "#cecece",
    "hover": "#a8a8a8"
  },
  "grey-900": {
    "default": "#ddd",
    "hover": "#bbb"
  },
  "grey-925": {
    "default": "#e5e5e5",
    "hover": "#c5c5c5"
  },
  "grey-950": {
    "default": "#eee",
    "hover": "#d2d2d2"
  },
  "grey-975": {
    "default": "#f6f6f6",
    "hover": "#dfdfdf"
  },
  "grey-1000": {
    "default": "#fff",
    "hover": "#f6f6f6"
  },
  "grey-main-525": {
    "default": "#7b7b7b",
    "hover": "#a6a6a6"
  },
  "blue-france-75": {
    "default": "#1b1b35",
    "hover": "#3a3a68"
  },
  "blue-france-100": {
    "default": "#21213f",
    "hover": "#424275"
  },
  "blue-france-125": {
    "default": "#272747",
    "hover": "#4a4a7d"
  },
  "blue-france-200": {
    "default": "#313178",
    "hover": "#5757ad"
  },
  "blue-france-625": {
    "default": "#8585f6",
    "hover": "#b1b1f9"
  },
  "blue-france-850": {
    "default": "#cacafb",
    "hover": "#a1a1f8"
  },
  "blue-france-925": {
    "default": "#e3e3fd",
    "hover": "#c1c1fb"
  },
  "blue-france-950": {
    "default": "#ececfe",
    "hover": "#cecefc"
  },
  "blue-france-975": {
    "default": "#f5f5fe",
    "hover": "#dcdcfc"
  },
  "blue-france-sun-113": {
    "default": "#000091",
    "hover": "#1212ff"
  },
  "blue-france-main-525": {
    "default": "#6a6af4",
    "hover": "#9898f8"
  },
  "red-marianne-75": {
    "default": "#2b1919",
    "hover": "#573737"
  },
  "red-marianne-100": {
    "default": "#331f1f",
    "hover": "#613f3f"
  },
  "red-marianne-125": {
    "default": "#3b2424",
    "hover": "#6b4545"
  },
  "red-marianne-200": {
    "default": "#5e2a2b",
    "hover": "#9c4a4c"
  },
  "red-marianne-425": {
    "default": "#c9191e",
    "hover": "#f93f42"
  },
  "red-marianne-625": {
    "default": "#f95c5e",
    "hover": "#fa9293"
  },
  "red-marianne-850": {
    "default": "#fcbfbf",
    "hover": "#fb8f8f"
  },
  "red-marianne-925": {
    "default": "#fddede",
    "hover": "#fbb6b6"
  },
  "red-marianne-950": {
    "default": "#fee9e9",
    "hover": "#fdc5c5"
  },
  "red-marianne-975": {
    "default": "#fef4f4",
    "hover": "#fcd7d7"
  },
  "red-marianne-main-472": {
    "default": "#e1000f",
    "hover": "#ff292f"
  },
  "info-75": {
    "default": "#171d2e",
    "hover": "#333e5c"
  },
  "info-100": {
    "default": "#1d2437",
    "hover": "#3b4767"
  },
  "info-125": {
    "default": "#222a3f",
    "hover": "#414e71"
  },
  "info-200": {
    "default": "#273961",
    "hover": "#45619f"
  },
  "info-425": {
    "default": "#0063cb",
    "hover": "#3b87ff"
  },
  "info-625": {
    "default": "#518fff",
    "hover": "#98b4ff"
  },
  "info-850": {
    "default": "#bccdff",
    "hover": "#83a9ff"
  },
  "info-925": {
    "default": "#dde5ff",
    "hover": "#b1c6ff"
  },
  "info-950": {
    "default": "#e8edff",
    "hover": "#c2d1ff"
  },
  "info-975": {
    "default": "#f4f6ff",
    "hover": "#d6deff"
  },
  "info-main-525": {
    "default": "#0078f3",
    "hover": "#6196ff"
  },
  "success-75": {
    "default": "#142117",
    "hover": "#2e4533"
  },
  "success-100": {
    "default": "#19271d",
    "hover": "#344c3b"
  },
  "success-125": {
    "default": "#1e2e22",
    "hover": "#3b5541"
  },
  "success-200": {
    "default": "#204129",
    "hover": "#3a6d48"
  },
  "success-425": {
    "default": "#18753c",
    "hover": "#27a959"
  },
  "success-625": {
    "default": "#27a658",
    "hover": "#36d975"
  },
  "success-850": {
    "default": "#3bea7e",
    "hover": "#2cb862"
  },
  "success-925": {
    "default": "#88fdaa",
    "hover": "#3ee87e"
  },
  "success-950": {
    "default": "#b8fec9",
    "hover": "#46fd89"
  },
  "success-975": {
    "default": "#dffee6",
    "hover": "#8afcab"
  },
  "success-main-525": {
    "default": "#1f8d49",
    "hover": "#2ec166"
  },
  "warning-75": {
    "default": "#2d1814",
    "hover": "#5b352e"
  },
  "warning-100": {
    "default": "#361e19",
    "hover": "#663d35"
  },
  "warning-125": {
    "default": "#3e231e",
    "hover": "#70433b"
  },
  "warning-200": {
    "default": "#5d2c20",
    "hover": "#9a4d3a"
  },
  "warning-425": {
    "default": "#b34000",
    "hover": "#ff6218"
  },
  "warning-625": {
    "default": "#fc5d00",
    "hover": "#ff8c73"
  },
  "warning-850": {
    "default": "#ffbeb4",
    "hover": "#ff8e77"
  },
  "warning-925": {
    "default": "#ffded9",
    "hover": "#ffb6a9"
  },
  "warning-950": {
    "default": "#ffe9e6",
    "hover": "#ffc6bd"
  },
  "warning-975": {
    "default": "#fff4f3",
    "hover": "#ffd7d3"
  },
  "warning-main-525": {
    "default": "#d64d00",
    "hover": "#ff754e"
  },
  "error-75": {
    "default": "#301717",
    "hover": "#603434"
  },
  "error-100": {
    "default": "#391c1c",
    "hover": "#6c3a3a"
  },
  "error-125": {
    "default": "#412121",
    "hover": "#764040"
  },
  "error-200": {
    "default": "#642626",
    "hover": "#a74545"
  },
  "error-425": {
    "default": "#ce0500",
    "hover": "#ff2725"
  },
  "error-625": {
    "default": "#ff5655",
    "hover": "#ff8c8c"
  },
  "error-850": {
    "default": "#ffbdbd",
    "hover": "#ff8c8c"
  },
  "error-925": {
    "default": "#fdd",
    "hover": "#ffb4b4"
  },
  "error-950": {
    "default": "#ffe9e9",
    "hover": "#ffc5c5"
  },
  "error-975": {
    "default": "#fff4f4",
    "hover": "#ffd7d7"
  },
  "error-main-525": {
    "default": "#f60700",
    "hover": "#ff3634"
  },
  "green-tilleul-verveine-75": {
    "default": "#201e14",
    "hover": "#433f2e"
  },
  "green-tilleul-verveine-100": {
    "default": "#272419",
    "hover": "#4c4734"
  },
  "green-tilleul-verveine-125": {
    "default": "#2d2a1d",
    "hover": "#534f39"
  },
  "green-tilleul-verveine-200": {
    "default": "#3f3a20",
    "hover": "#6a6239"
  },
  "green-tilleul-verveine-850": {
    "default": "#e2cf58",
    "hover": "#b7a846"
  },
  "green-tilleul-verveine-925": {
    "default": "#fbe769",
    "hover": "#d7c655"
  },
  "green-tilleul-verveine-950": {
    "default": "#fceeac",
    "hover": "#e8d45c"
  },
  "green-tilleul-verveine-975": {
    "default": "#fef7da",
    "hover": "#fce552"
  },
  "green-tilleul-verveine-sun-418": {
    "default": "#66673d",
    "hover": "#929359"
  },
  "green-tilleul-verveine-moon-817": {
    "default": "#d8c634",
    "hover": "#fee943"
  },
  "green-tilleul-verveine-main-707": {
    "default": "#b7a73f",
    "hover": "#e3cf50"
  },
  "green-bourgeon-75": {
    "default": "#182014",
    "hover": "#35432e"
  },
  "green-bourgeon-100": {
    "default": "#1e2719",
    "hover": "#3d4c34"
  },
  "green-bourgeon-125": {
    "default": "#232d1d",
    "hover": "#435339"
  },
  "green-bourgeon-200": {
    "default": "#2a401a",
    "hover": "#496b30"
  },
  "green-bourgeon-850": {
    "default": "#95e257",
    "hover": "#77b645"
  },
  "green-bourgeon-925": {
    "default": "#a9fb68",
    "hover": "#8ed654"
  },
  "green-bourgeon-950": {
    "default": "#c9fcac",
    "hover": "#9ae95d"
  },
  "green-bourgeon-975": {
    "default": "#e6feda",
    "hover": "#a7fc62"
  },
  "green-bourgeon-sun-425": {
    "default": "#447049",
    "hover": "#639f6a"
  },
  "green-bourgeon-moon-759": {
    "default": "#99c221",
    "hover": "#baec2a"
  },
  "green-bourgeon-main-640": {
    "default": "#68a532",
    "hover": "#87d443"
  },
  "green-emeraude-75": {
    "default": "#142018",
    "hover": "#2e4335"
  },
  "green-emeraude-100": {
    "default": "#19271e",
    "hover": "#344c3d"
  },
  "green-emeraude-125": {
    "default": "#1e2e23",
    "hover": "#3b5543"
  },
  "green-emeraude-200": {
    "default": "#21402c",
    "hover": "#3b6c4c"
  },
  "green-emeraude-850": {
    "default": "#6fe49d",
    "hover": "#58b77d"
  },
  "green-emeraude-925": {
    "default": "#9ef9be",
    "hover": "#69df97"
  },
  "green-emeraude-950": {
    "default": "#c3fad5",
    "hover": "#77eda5"
  },
  "green-emeraude-975": {
    "default": "#e3fdeb",
    "hover": "#94f9b9"
  },
  "green-emeraude-sun-425": {
    "default": "#297254",
    "hover": "#3ea47a"
  },
  "green-emeraude-moon-753": {
    "default": "#34cb6a",
    "hover": "#42fb84"
  },
  "green-emeraude-main-632": {
    "default": "#00a95f",
    "hover": "#00e180"
  },
  "green-menthe-75": {
    "default": "#15201e",
    "hover": "#30433f"
  },
  "green-menthe-100": {
    "default": "#1a2624",
    "hover": "#364b47"
  },
  "green-menthe-125": {
    "default": "#1f2d2a",
    "hover": "#3c534e"
  },
  "green-menthe-200": {
    "default": "#223f3a",
    "hover": "#3d6a62"
  },
  "green-menthe-850": {
    "default": "#73e0cf",
    "hover": "#5bb5a7"
  },
  "green-menthe-925": {
    "default": "#8bf8e7",
    "hover": "#6ed5c5"
  },
  "green-menthe-950": {
    "default": "#bafaee",
    "hover": "#79e7d5"
  },
  "green-menthe-975": {
    "default": "#dffdf7",
    "hover": "#84f9e7"
  },
  "green-menthe-sun-373": {
    "default": "#37635f",
    "hover": "#53918c"
  },
  "green-menthe-moon-652": {
    "default": "#21ab8e",
    "hover": "#2eddb8"
  },
  "green-menthe-main-548": {
    "default": "#009081",
    "hover": "#00c7b3"
  },
  "green-archipel-75": {
    "default": "#152021",
    "hover": "#2f4345"
  },
  "green-archipel-100": {
    "default": "#1a2628",
    "hover": "#364a4e"
  },
  "green-archipel-125": {
    "default": "#1f2c2e",
    "hover": "#3c5255"
  },
  "green-archipel-200": {
    "default": "#233e41",
    "hover": "#3e686d"
  },
  "green-archipel-850": {
    "default": "#60e0eb",
    "hover": "#4cb4bd"
  },
  "green-archipel-925": {
    "default": "#a6f2fa",
    "hover": "#62dbe5"
  },
  "green-archipel-950": {
    "default": "#c7f6fc",
    "hover": "#64ecf8"
  },
  "green-archipel-975": {
    "default": "#e5fbfd",
    "hover": "#99f2f8"
  },
  "green-archipel-sun-391": {
    "default": "#006a6f",
    "hover": "#009fa7"
  },
  "green-archipel-moon-716": {
    "default": "#34bab5",
    "hover": "#43e9e2"
  },
  "green-archipel-main-557": {
    "default": "#009099",
    "hover": "#00c6d2"
  },
  "blue-ecume-75": {
    "default": "#171d2f",
    "hover": "#333e5e"
  },
  "blue-ecume-100": {
    "default": "#1d2437",
    "hover": "#3b4767"
  },
  "blue-ecume-125": {
    "default": "#222940",
    "hover": "#424d73"
  },
  "blue-ecume-200": {
    "default": "#273962",
    "hover": "#4561a1"
  },
  "blue-ecume-850": {
    "default": "#bfccfb",
    "hover": "#8ba7f8"
  },
  "blue-ecume-925": {
    "default": "#dee5fd",
    "hover": "#b4c5fb"
  },
  "blue-ecume-950": {
    "default": "#e9edfe",
    "hover": "#c5d0fc"
  },
  "blue-ecume-975": {
    "default": "#f4f6fe",
    "hover": "#d7dffb"
  },
  "blue-ecume-sun-247": {
    "default": "#2f4077",
    "hover": "#4e68bb"
  },
  "blue-ecume-moon-675": {
    "default": "#869ece",
    "hover": "#b8c5e2"
  },
  "blue-ecume-main-400": {
    "default": "#465f9d",
    "hover": "#6f89d1"
  },
  "blue-cumulus-75": {
    "default": "#171e2b",
    "hover": "#333f56"
  },
  "blue-cumulus-100": {
    "default": "#1c2433",
    "hover": "#3a4761"
  },
  "blue-cumulus-125": {
    "default": "#212a3a",
    "hover": "#404f69"
  },
  "blue-cumulus-200": {
    "default": "#263b58",
    "hover": "#436491"
  },
  "blue-cumulus-850": {
    "default": "#b6cffb",
    "hover": "#76adf8"
  },
  "blue-cumulus-925": {
    "default": "#dae6fd",
    "hover": "#a9c8fb"
  },
  "blue-cumulus-950": {
    "default": "#e6eefe",
    "hover": "#bcd3fc"
  },
  "blue-cumulus-975": {
    "default": "#f3f6fe",
    "hover": "#d3dffc"
  },
  "blue-cumulus-sun-368": {
    "default": "#3558a2",
    "hover": "#5982e0"
  },
  "blue-cumulus-moon-732": {
    "default": "#7ab1e8",
    "hover": "#bad2f2"
  },
  "blue-cumulus-main-526": {
    "default": "#417dc4",
    "hover": "#74a5ec"
  },
  "purple-glycine-75": {
    "default": "#251a24",
    "hover": "#4c394a"
  },
  "purple-glycine-100": {
    "default": "#2c202b",
    "hover": "#554053"
  },
  "purple-glycine-125": {
    "default": "#332632",
    "hover": "#5d485c"
  },
  "purple-glycine-200": {
    "default": "#502e4d",
    "hover": "#855080"
  },
  "purple-glycine-850": {
    "default": "#fbb8f6",
    "hover": "#f983f1"
  },
  "purple-glycine-925": {
    "default": "#fddbfa",
    "hover": "#fbaff5"
  },
  "purple-glycine-950": {
    "default": "#fee7fc",
    "hover": "#fdc0f8"
  },
  "purple-glycine-975": {
    "default": "#fef3fd",
    "hover": "#fcd4f8"
  },
  "purple-glycine-sun-319": {
    "default": "#6e445a",
    "hover": "#a66989"
  },
  "purple-glycine-moon-630": {
    "default": "#ce70cc",
    "hover": "#dfa4dd"
  },
  "purple-glycine-main-494": {
    "default": "#a558a0",
    "hover": "#d282cd"
  },
  "pink-macaron-75": {
    "default": "#261b19",
    "hover": "#4e3a37"
  },
  "pink-macaron-100": {
    "default": "#2e211f",
    "hover": "#58423f"
  },
  "pink-macaron-125": {
    "default": "#352724",
    "hover": "#614a45"
  },
  "pink-macaron-200": {
    "default": "#52312a",
    "hover": "#885449"
  },
  "pink-macaron-850": {
    "default": "#fcc0b4",
    "hover": "#fb9175"
  },
  "pink-macaron-925": {
    "default": "#fddfda",
    "hover": "#fbb8ab"
  },
  "pink-macaron-950": {
    "default": "#fee9e6",
    "hover": "#fdc6bd"
  },
  "pink-macaron-975": {
    "default": "#fef4f2",
    "hover": "#fcd8d0"
  },
  "pink-macaron-sun-406": {
    "default": "#8d533e",
    "hover": "#ca795c"
  },
  "pink-macaron-moon-833": {
    "default": "#ffb7ae",
    "hover": "#ffe0dc"
  },
  "pink-macaron-main-689": {
    "default": "#e18b76",
    "hover": "#eabab1"
  },
  "pink-tuile-75": {
    "default": "#281b19",
    "hover": "#513a37"
  },
  "pink-tuile-100": {
    "default": "#2f211f",
    "hover": "#5a423e"
  },
  "pink-tuile-125": {
    "default": "#372624",
    "hover": "#644845"
  },
  "pink-tuile-200": {
    "default": "#55302a",
    "hover": "#8d5349"
  },
  "pink-tuile-850": {
    "default": "#fcbfb7",
    "hover": "#fb907d"
  },
  "pink-tuile-925": {
    "default": "#fddfdb",
    "hover": "#fbb8ad"
  },
  "pink-tuile-950": {
    "default": "#fee9e7",
    "hover": "#fdc6c0"
  },
  "pink-tuile-975": {
    "default": "#fef4f3",
    "hover": "#fcd7d3"
  },
  "pink-tuile-sun-425": {
    "default": "#a94645",
    "hover": "#d5706f"
  },
  "pink-tuile-moon-750": {
    "default": "#ff9575",
    "hover": "#ffc4b7"
  },
  "pink-tuile-main-556": {
    "default": "#ce614a",
    "hover": "#e89082"
  },
  "yellow-tournesol-75": {
    "default": "#221d11",
    "hover": "#473e29"
  },
  "yellow-tournesol-100": {
    "default": "#292416",
    "hover": "#4f472f"
  },
  "yellow-tournesol-125": {
    "default": "#302a1a",
    "hover": "#584e34"
  },
  "yellow-tournesol-200": {
    "default": "#43391a",
    "hover": "#706030"
  },
  "yellow-tournesol-850": {
    "default": "#efcb3a",
    "hover": "#c1a42d"
  },
  "yellow-tournesol-925": {
    "default": "#fde39c",
    "hover": "#e9c53b"
  },
  "yellow-tournesol-950": {
    "default": "#feecc2",
    "hover": "#fbd335"
  },
  "yellow-tournesol-975": {
    "default": "#fef6e3",
    "hover": "#fce086"
  },
  "yellow-tournesol-sun-407": {
    "default": "#716043",
    "hover": "#a28a62"
  },
  "yellow-tournesol-moon-922": {
    "default": "#ffe552",
    "hover": "#e1c700"
  },
  "yellow-tournesol-main-731": {
    "default": "#c8aa39",
    "hover": "#967f29"
  },
  "yellow-moutarde-75": {
    "default": "#231d14",
    "hover": "#483e2e"
  },
  "yellow-moutarde-100": {
    "default": "#2a2319",
    "hover": "#514534"
  },
  "yellow-moutarde-125": {
    "default": "#30291d",
    "hover": "#584d39"
  },
  "yellow-moutarde-200": {
    "default": "#453820",
    "hover": "#735f39"
  },
  "yellow-moutarde-850": {
    "default": "#fcc63a",
    "hover": "#cb9f2d"
  },
  "yellow-moutarde-925": {
    "default": "#fde2b5",
    "hover": "#f6c43c"
  },
  "yellow-moutarde-950": {
    "default": "#feebd0",
    "hover": "#fdcd6d"
  },
  "yellow-moutarde-975": {
    "default": "#fef5e8",
    "hover": "#fcdca3"
  },
  "yellow-moutarde-sun-348": {
    "default": "#695240",
    "hover": "#9b7b61"
  },
  "yellow-moutarde-moon-860": {
    "default": "#ffca00",
    "hover": "#cda200"
  },
  "yellow-moutarde-main-679": {
    "default": "#c3992a",
    "hover": "#f5c137"
  },
  "orange-terre-battue-75": {
    "default": "#281a16",
    "hover": "#513932"
  },
  "orange-terre-battue-100": {
    "default": "#31201c",
    "hover": "#5d403a"
  },
  "orange-terre-battue-125": {
    "default": "#382621",
    "hover": "#664840"
  },
  "orange-terre-battue-200": {
    "default": "#543125",
    "hover": "#8b5442"
  },
  "orange-terre-battue-850": {
    "default": "#fcc0b0",
    "hover": "#fb926b"
  },
  "orange-terre-battue-925": {
    "default": "#fddfd8",
    "hover": "#fbb8a5"
  },
  "orange-terre-battue-950": {
    "default": "#fee9e5",
    "hover": "#fdc6ba"
  },
  "orange-terre-battue-975": {
    "default": "#fef4f2",
    "hover": "#fcd8d0"
  },
  "orange-terre-battue-sun-370": {
    "default": "#755348",
    "hover": "#ab7b6b"
  },
  "orange-terre-battue-moon-672": {
    "default": "#ff732c",
    "hover": "#ffa48b"
  },
  "orange-terre-battue-main-645": {
    "default": "#e4794a",
    "hover": "#f1a892"
  },
  "brown-cafe-creme-75": {
    "default": "#211d16",
    "hover": "#453e31"
  },
  "brown-cafe-creme-100": {
    "default": "#28241c",
    "hover": "#4e4739"
  },
  "brown-cafe-creme-125": {
    "default": "#2e2a21",
    "hover": "#554e3f"
  },
  "brown-cafe-creme-200": {
    "default": "#423925",
    "hover": "#6e6041"
  },
  "brown-cafe-creme-850": {
    "default": "#e7ca8e",
    "hover": "#bca473"
  },
  "brown-cafe-creme-925": {
    "default": "#f4e3c7",
    "hover": "#e1c386"
  },
  "brown-cafe-creme-950": {
    "default": "#f7ecdb",
    "hover": "#edce94"
  },
  "brown-cafe-creme-975": {
    "default": "#fbf6ed",
    "hover": "#f2deb6"
  },
  "brown-cafe-creme-sun-383": {
    "default": "#685c48",
    "hover": "#97866a"
  },
  "brown-cafe-creme-moon-885": {
    "default": "#ecd7a2",
    "hover": "#c5b386"
  },
  "brown-cafe-creme-main-782": {
    "default": "#d1b781",
    "hover": "#a38e63"
  },
  "brown-caramel-75": {
    "default": "#251c16",
    "hover": "#4c3c31"
  },
  "brown-caramel-100": {
    "default": "#2c221c",
    "hover": "#554439"
  },
  "brown-caramel-125": {
    "default": "#332821",
    "hover": "#5d4b40"
  },
  "brown-caramel-200": {
    "default": "#4b3525",
    "hover": "#7c5a41"
  },
  "brown-caramel-850": {
    "default": "#eac7b2",
    "hover": "#d69e75"
  },
  "brown-caramel-925": {
    "default": "#f3e2d9",
    "hover": "#e7bea6"
  },
  "brown-caramel-950": {
    "default": "#f7ebe5",
    "hover": "#eccbb9"
  },
  "brown-caramel-975": {
    "default": "#fbf5f2",
    "hover": "#f1dbcf"
  },
  "brown-caramel-sun-425": {
    "default": "#845d48",
    "hover": "#bb8568"
  },
  "brown-caramel-moon-901": {
    "default": "#fbd8ab",
    "hover": "#efb547"
  },
  "brown-caramel-main-648": {
    "default": "#c08c65",
    "hover": "#e6b594"
  },
  "brown-opera-75": {
    "default": "#241c17",
    "hover": "#4a3c33"
  },
  "brown-opera-100": {
    "default": "#2b221c",
    "hover": "#53443a"
  },
  "brown-opera-125": {
    "default": "#322821",
    "hover": "#5c4b40"
  },
  "brown-opera-200": {
    "default": "#493625",
    "hover": "#795c41"
  },
  "brown-opera-850": {
    "default": "#eac7ad",
    "hover": "#d09f74"
  },
  "brown-opera-925": {
    "default": "#f3e2d7",
    "hover": "#e7bfa0"
  },
  "brown-opera-950": {
    "default": "#f7ece4",
    "hover": "#eccdb3"
  },
  "brown-opera-975": {
    "default": "#fbf5f2",
    "hover": "#f1dbcf"
  },
  "brown-opera-sun-395": {
    "default": "#745b47",
    "hover": "#a78468"
  },
  "brown-opera-moon-820": {
    "default": "#e6be92",
    "hover": "#f2e2d3"
  },
  "brown-opera-main-680": {
    "default": "#bd987a",
    "hover": "#e1c0a8"
  },
  "beige-gris-galet-75": {
    "default": "#211d19",
    "hover": "#453e37"
  },
  "beige-gris-galet-100": {
    "default": "#28231f",
    "hover": "#4e453f"
  },
  "beige-gris-galet-125": {
    "default": "#2e2924",
    "hover": "#554d45"
  },
  "beige-gris-galet-200": {
    "default": "#433829",
    "hover": "#705f47"
  },
  "beige-gris-galet-850": {
    "default": "#e0cab0",
    "hover": "#baa48a"
  },
  "beige-gris-galet-925": {
    "default": "#eee4d9",
    "hover": "#dbc3a4"
  },
  "beige-gris-galet-950": {
    "default": "#f3ede5",
    "hover": "#e1d0b5"
  },
  "beige-gris-galet-975": {
    "default": "#f9f6f2",
    "hover": "#eadecd"
  },
  "beige-gris-galet-sun-407": {
    "default": "#6a6156",
    "hover": "#988b7c"
  },
  "beige-gris-galet-moon-821": {
    "default": "#d0c3b7",
    "hover": "#eae5e1"
  },
  "beige-gris-galet-main-702": {
    "default": "#aea397",
    "hover": "#d5cabd"
  }
}

export const DSFR_PALETTE_CATEGORY_ORDER = [
  "grey",
  "blue-france",
  "red-marianne",
  "info",
  "success",
  "warning",
  "error",
  "green-tilleul-verveine",
  "green-bourgeon",
  "green-emeraude",
  "green-menthe",
  "green-archipel",
  "blue-ecume",
  "blue-cumulus",
  "purple-glycine",
  "pink-macaron",
  "pink-tuile",
  "yellow-tournesol",
  "yellow-moutarde",
  "orange-terre-battue",
  "brown-cafe-creme",
  "brown-caramel",
  "brown-opera",
  "beige-gris-galet"
]

export const DSFR_PALETTE_CATEGORY_LABELS = {
  "grey": "Neutre (gris)",
  "blue-france": "Bleu France",
  "red-marianne": "Rouge Marianne",
  "info": "Info",
  "success": "Succès",
  "warning": "Avertissement",
  "error": "Erreur",
  "green-tilleul-verveine": "Vert tilleul verveine",
  "green-bourgeon": "Vert bourgeon",
  "green-emeraude": "Vert émeraude",
  "green-menthe": "Vert menthe",
  "green-archipel": "Vert archipel",
  "blue-ecume": "Bleu écume",
  "blue-cumulus": "Bleu cumulus",
  "purple-glycine": "Violet glycine",
  "pink-macaron": "Rose macaron",
  "pink-tuile": "Rose tuile",
  "yellow-tournesol": "Jaune tournesol",
  "yellow-moutarde": "Jaune moutarde",
  "orange-terre-battue": "Orange terre battue",
  "brown-cafe-creme": "Brun café crème",
  "brown-caramel": "Brun caramel",
  "brown-opera": "Brun opéra",
  "beige-gris-galet": "Beige gris galet"
}

export const DSFR_PALETTE_CATEGORIES = {
  "grey": [
    "grey-0",
    "grey-100",
    "grey-1000",
    "grey-125",
    "grey-150",
    "grey-175",
    "grey-200",
    "grey-425",
    "grey-50",
    "grey-625",
    "grey-75",
    "grey-850",
    "grey-900",
    "grey-925",
    "grey-950",
    "grey-975",
    "grey-main-525"
  ],
  "blue-france": [
    "blue-france-100",
    "blue-france-125",
    "blue-france-200",
    "blue-france-625",
    "blue-france-75",
    "blue-france-850",
    "blue-france-925",
    "blue-france-950",
    "blue-france-975",
    "blue-france-main-525",
    "blue-france-sun-113"
  ],
  "red-marianne": [
    "red-marianne-100",
    "red-marianne-125",
    "red-marianne-200",
    "red-marianne-425",
    "red-marianne-625",
    "red-marianne-75",
    "red-marianne-850",
    "red-marianne-925",
    "red-marianne-950",
    "red-marianne-975",
    "red-marianne-main-472"
  ],
  "info": [
    "info-100",
    "info-125",
    "info-200",
    "info-425",
    "info-625",
    "info-75",
    "info-850",
    "info-925",
    "info-950",
    "info-975",
    "info-main-525"
  ],
  "success": [
    "success-100",
    "success-125",
    "success-200",
    "success-425",
    "success-625",
    "success-75",
    "success-850",
    "success-925",
    "success-950",
    "success-975",
    "success-main-525"
  ],
  "warning": [
    "warning-100",
    "warning-125",
    "warning-200",
    "warning-425",
    "warning-625",
    "warning-75",
    "warning-850",
    "warning-925",
    "warning-950",
    "warning-975",
    "warning-main-525"
  ],
  "error": [
    "error-100",
    "error-125",
    "error-200",
    "error-425",
    "error-625",
    "error-75",
    "error-850",
    "error-925",
    "error-950",
    "error-975",
    "error-main-525"
  ],
  "green-tilleul-verveine": [
    "green-tilleul-verveine-100",
    "green-tilleul-verveine-125",
    "green-tilleul-verveine-200",
    "green-tilleul-verveine-75",
    "green-tilleul-verveine-850",
    "green-tilleul-verveine-925",
    "green-tilleul-verveine-950",
    "green-tilleul-verveine-975",
    "green-tilleul-verveine-main-707",
    "green-tilleul-verveine-moon-817",
    "green-tilleul-verveine-sun-418"
  ],
  "green-bourgeon": [
    "green-bourgeon-100",
    "green-bourgeon-125",
    "green-bourgeon-200",
    "green-bourgeon-75",
    "green-bourgeon-850",
    "green-bourgeon-925",
    "green-bourgeon-950",
    "green-bourgeon-975",
    "green-bourgeon-main-640",
    "green-bourgeon-moon-759",
    "green-bourgeon-sun-425"
  ],
  "green-emeraude": [
    "green-emeraude-100",
    "green-emeraude-125",
    "green-emeraude-200",
    "green-emeraude-75",
    "green-emeraude-850",
    "green-emeraude-925",
    "green-emeraude-950",
    "green-emeraude-975",
    "green-emeraude-main-632",
    "green-emeraude-moon-753",
    "green-emeraude-sun-425"
  ],
  "green-menthe": [
    "green-menthe-100",
    "green-menthe-125",
    "green-menthe-200",
    "green-menthe-75",
    "green-menthe-850",
    "green-menthe-925",
    "green-menthe-950",
    "green-menthe-975",
    "green-menthe-main-548",
    "green-menthe-moon-652",
    "green-menthe-sun-373"
  ],
  "green-archipel": [
    "green-archipel-100",
    "green-archipel-125",
    "green-archipel-200",
    "green-archipel-75",
    "green-archipel-850",
    "green-archipel-925",
    "green-archipel-950",
    "green-archipel-975",
    "green-archipel-main-557",
    "green-archipel-moon-716",
    "green-archipel-sun-391"
  ],
  "blue-ecume": [
    "blue-ecume-100",
    "blue-ecume-125",
    "blue-ecume-200",
    "blue-ecume-75",
    "blue-ecume-850",
    "blue-ecume-925",
    "blue-ecume-950",
    "blue-ecume-975",
    "blue-ecume-main-400",
    "blue-ecume-moon-675",
    "blue-ecume-sun-247"
  ],
  "blue-cumulus": [
    "blue-cumulus-100",
    "blue-cumulus-125",
    "blue-cumulus-200",
    "blue-cumulus-75",
    "blue-cumulus-850",
    "blue-cumulus-925",
    "blue-cumulus-950",
    "blue-cumulus-975",
    "blue-cumulus-main-526",
    "blue-cumulus-moon-732",
    "blue-cumulus-sun-368"
  ],
  "purple-glycine": [
    "purple-glycine-100",
    "purple-glycine-125",
    "purple-glycine-200",
    "purple-glycine-75",
    "purple-glycine-850",
    "purple-glycine-925",
    "purple-glycine-950",
    "purple-glycine-975",
    "purple-glycine-main-494",
    "purple-glycine-moon-630",
    "purple-glycine-sun-319"
  ],
  "pink-macaron": [
    "pink-macaron-100",
    "pink-macaron-125",
    "pink-macaron-200",
    "pink-macaron-75",
    "pink-macaron-850",
    "pink-macaron-925",
    "pink-macaron-950",
    "pink-macaron-975",
    "pink-macaron-main-689",
    "pink-macaron-moon-833",
    "pink-macaron-sun-406"
  ],
  "pink-tuile": [
    "pink-tuile-100",
    "pink-tuile-125",
    "pink-tuile-200",
    "pink-tuile-75",
    "pink-tuile-850",
    "pink-tuile-925",
    "pink-tuile-950",
    "pink-tuile-975",
    "pink-tuile-main-556",
    "pink-tuile-moon-750",
    "pink-tuile-sun-425"
  ],
  "yellow-tournesol": [
    "yellow-tournesol-100",
    "yellow-tournesol-125",
    "yellow-tournesol-200",
    "yellow-tournesol-75",
    "yellow-tournesol-850",
    "yellow-tournesol-925",
    "yellow-tournesol-950",
    "yellow-tournesol-975",
    "yellow-tournesol-main-731",
    "yellow-tournesol-moon-922",
    "yellow-tournesol-sun-407"
  ],
  "yellow-moutarde": [
    "yellow-moutarde-100",
    "yellow-moutarde-125",
    "yellow-moutarde-200",
    "yellow-moutarde-75",
    "yellow-moutarde-850",
    "yellow-moutarde-925",
    "yellow-moutarde-950",
    "yellow-moutarde-975",
    "yellow-moutarde-main-679",
    "yellow-moutarde-moon-860",
    "yellow-moutarde-sun-348"
  ],
  "orange-terre-battue": [
    "orange-terre-battue-100",
    "orange-terre-battue-125",
    "orange-terre-battue-200",
    "orange-terre-battue-75",
    "orange-terre-battue-850",
    "orange-terre-battue-925",
    "orange-terre-battue-950",
    "orange-terre-battue-975",
    "orange-terre-battue-main-645",
    "orange-terre-battue-moon-672",
    "orange-terre-battue-sun-370"
  ],
  "brown-cafe-creme": [
    "brown-cafe-creme-100",
    "brown-cafe-creme-125",
    "brown-cafe-creme-200",
    "brown-cafe-creme-75",
    "brown-cafe-creme-850",
    "brown-cafe-creme-925",
    "brown-cafe-creme-950",
    "brown-cafe-creme-975",
    "brown-cafe-creme-main-782",
    "brown-cafe-creme-moon-885",
    "brown-cafe-creme-sun-383"
  ],
  "brown-caramel": [
    "brown-caramel-100",
    "brown-caramel-125",
    "brown-caramel-200",
    "brown-caramel-75",
    "brown-caramel-850",
    "brown-caramel-925",
    "brown-caramel-950",
    "brown-caramel-975",
    "brown-caramel-main-648",
    "brown-caramel-moon-901",
    "brown-caramel-sun-425"
  ],
  "brown-opera": [
    "brown-opera-100",
    "brown-opera-125",
    "brown-opera-200",
    "brown-opera-75",
    "brown-opera-850",
    "brown-opera-925",
    "brown-opera-950",
    "brown-opera-975",
    "brown-opera-main-680",
    "brown-opera-moon-820",
    "brown-opera-sun-395"
  ],
  "beige-gris-galet": [
    "beige-gris-galet-100",
    "beige-gris-galet-125",
    "beige-gris-galet-200",
    "beige-gris-galet-75",
    "beige-gris-galet-850",
    "beige-gris-galet-925",
    "beige-gris-galet-950",
    "beige-gris-galet-975",
    "beige-gris-galet-main-702",
    "beige-gris-galet-moon-821",
    "beige-gris-galet-sun-407"
  ]
}
